import { useState, useCallback } from 'react'
import '../styles/app.css'
import { Icon } from './Icon'

export const TrustMessage = (props) => {

    const [ isOpen , setIsOpen ] = useState(false)
    const [ isBouncing, setIsBouncing ] = useState(true)

    const { iconName, text } = props

    const handleOpen = useCallback(() => {
        setIsBouncing(false)
        setIsOpen(true)
    }, [])

    const handleClose = useCallback((e) => {
        e.stopPropagation()
        setIsOpen(false)
    }, [])

    const handleTransitionEnd = useCallback((e) => {
        if (e.target.classList.contains('TrustMessage') && !e.target.classList.contains('isOpen')) {
            setIsBouncing(true)
        }
    }, [])

    return (
        <div className={`TrustMessage ${isOpen ? 'isOpen' : ''} ${isBouncing ? 'isBouncing' : ''}`}
            onPointerDown={handleOpen}
            onTransitionEnd={handleTransitionEnd}>
            <div className="TrustMessage-div">
                <Icon name={iconName}/>
                <h3 className="TrustMessage-h3">{text}</h3>
            </div>
            <button className="TrustMessage-btn" onPointerDown={handleClose}>
                <Icon name="close" />
            </button>
        </div>
    )

}
